import { Routes, Route, Navigate } from "react-router-dom";
import AdminOwnerMemberProfile from "../AdminPortal/AdminOwnerMemberProfile";
import AdminOwnerProfileAccount from "../AdminPortal/AdminOwnerProfileAccount";

const PROFILE_BASE = "/staff/app/profile";
const ACCOUNT_BASE = `${PROFILE_BASE}/account`;

export default function StaffProfile() {
  return (
    <Routes>
      <Route
        index
        element={<AdminOwnerMemberProfile accountBase={ACCOUNT_BASE} />}
      />
      <Route
        path="account/*"
        element={
          <AdminOwnerProfileAccount
            profileBase={PROFILE_BASE}
            accountBase={ACCOUNT_BASE}
            showBilling={false}
          />
        }
      />
      <Route
        path="settings"
        element={<Navigate to={ACCOUNT_BASE} replace />}
      />
      <Route path="*" element={<Navigate to={PROFILE_BASE} replace />} />
    </Routes>
  );
}
